import { render, staticRenderFns } from "./schoolSearch.vue?vue&type=template&id=18ca77d2&"
import script from "./schoolSearch.vue?vue&type=script&lang=js&"
export * from "./schoolSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports